import React, { useState, useContext } from 'react';
import styles from './CircularDiagram.module.css';
import { Row, Col, Container } from 'reactstrap';
import CircleIllustration from '../../assets/images/Vendor/MCC/Circle-Illustration.png';
import BrandedIcon from '../../components/BrandingWhiteLabel/BrandedIcon';
import { SessionContext } from '../../context/SessionContext';
import EnrollmentModal from '../../components/Modals/Enrollment/Enrollment';

const CircularDiagramMCC = () => {
    const sessionContext = useContext(SessionContext);
    const { accountName } = sessionContext;
    const [showEnrollmentModal, setShowEnrollmentModal] = useState(false);

    const nodes = [
        {
            id: 1,
            label: (
                <>
                    <span>Stand Out</span> by Adding Value to Every Quote
                </>
            )
        },
        {
            id: 2,
            label: (
                <>
                    <span>Maintain Customer Relationships</span>
                </>
            )
        },
        {
            id: 3,
            label: (
                <>
                    Be a <span>Service Hero</span> During Breakdowns
                </>
            )
        },
        {
            id: 4,
            label: (
                <>
                    <span>Gain Referrals</span> from Satisfied Customers
                </>
            )
        },
        {
            id: 5,
            label: (
                <>
                    <span>Earn Extra</span> Revenue on Every Installation
                </>
            )
        },
        {
            id: 6,
            label: (
                <>
                    Coverage Can Help Add to the <span>Home Resale Value</span>
                </>
            )
        }
    ];

    const handleGetStarted = () => {
        setShowEnrollmentModal(true);
    };

    const DealerServiceInfo = ({ iconType, title, text }) => {
        return (
            <Col
                xs='12'
                sm='6'
                md='6'
                lg='3'
                xl='3'
                className={styles.infoContainerMCC}
            >
                <div>
                    <div className={styles.loginIconMCC}>
                        <BrandedIcon
                            accountName={accountName}
                            iconType={iconType}
                        />
                    </div>
                    <div>
                        <h3 className='mb-2 text-left text-md-left text-lg-center'>
                            {title.split('<br>').map((line, index) => (
                                <span key={index}>
                                    {line}
                                    <br />
                                </span>
                            ))}
                        </h3>
                    </div>
                </div>
            </Col>
        );
    };

    return (
        <>
            <div className={styles.mccDiagramContainer}>
                <div className={styles.mccDiagram}>
                    <img
                        src={CircleIllustration}
                        alt='Cycle Illustration'
                        className={styles.image}
                    />
                    <div className={styles.centerText}>
                        <h1>
                            <div className={styles.line}>
                                <span className={styles.blueText}>
                                    <h1>INCREASE</h1>
                                </span>
                                <span className={styles.darkText}>
                                    <h1>engagement,</h1>
                                </span>
                            </div>
                            <div className={styles.line}>
                                <span className={styles.blueText}>
                                    <h1>IMPROVE</h1>
                                </span>
                                <span className={styles.darkText}>
                                    <h1>conversion,</h1>
                                </span>
                            </div>
                            <div className={styles.line}>
                                <span className={styles.blueText}>
                                    <h1>EARN MORE</h1>
                                </span>
                            </div>
                        </h1>
                    </div>
                    {nodes.map((node, index) => (
                        <div
                            key={node.id}
                            className={`${styles.node} ${styles[`node${index}`]}`}
                        >
                            <span className={styles.nodeLabel}>{node.label}</span>
                        </div>
                    ))}

                    {showEnrollmentModal && (
                        <EnrollmentModal
                            isOpen={showEnrollmentModal}
                            centered={true}
                            toggle={() => setShowEnrollmentModal(!showEnrollmentModal)}
                            accountName={accountName}
                        />
                    )}
                </div>
            </div>

            <Container
                fluid
                className={styles.contentContainerMobile}
            >
                <Container className={styles.contentContainerMCC}>
                    <Row>
                        <Col>
                            <div className={styles.centerText}>
                                <h1>
                                    <div className={styles.line}>
                                        <span className={styles.blueText}>
                                            <h1>INCREASE</h1>
                                        </span>
                                        <span className={styles.darkText}>
                                            <h1>engagement,</h1>
                                        </span>
                                    </div>
                                    <div className={styles.line}>
                                        <span className={styles.blueText}>
                                            <h1>IMPROVE</h1>
                                        </span>
                                        <span className={styles.darkText}>
                                            <h1>conversion,</h1>
                                        </span>
                                    </div>
                                    <div className={styles.line}>
                                        <span className={styles.blueText}>
                                            <h1>EARN MORE</h1>
                                        </span>
                                    </div>
                                </h1>
                            </div>
                        </Col>
                    </Row>
                    <Row className={styles.iconContainerMcc}>
                        <Col
                            sm='12'
                            md='12'
                            lg='12'
                        >
                            <Row className={styles.serviceInfoContainer}>
                                <DealerServiceInfo
                                    iconType='partnership'
                                    title='Maintain Customer <br>Relationships'
                                />
                                <DealerServiceInfo
                                    iconType='superhero'
                                    title='Be a Service Hero <br>During Breakdowns'
                                />
                                <DealerServiceInfo
                                    iconType='referral'
                                    title='Gain Referrals from <br>Satisfied Customers'
                                />
                                <DealerServiceInfo
                                    iconType='earn'
                                    title='Earn Extra Revenue on <br>Every Installation'
                                />
                                <DealerServiceInfo
                                    iconType='value'
                                    title='Coverage Can Help Add to <br>the Home Resale Value'
                                />
                                <DealerServiceInfo
                                    iconType='standout'
                                    title='Stand Out by Adding <br>Value to Every Quote'
                                />
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </Container>

            <div className={styles.getStartedContainer}>
                <h2 className={styles.heading}>Do you want to create opportunities for extra revenue?</h2>
                <button
                    className={styles.getStartedButton}
                    onClick={(e) => handleGetStarted()}
                >
                    GET STARTED TODAY
                </button>
            </div>
        </>
    );
};

export default CircularDiagramMCC;
